import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getNews(params) {
  return request({
    url: '/GetNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 201,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        SortOrder: params.sortOrder,
        SortField: params.sortField,
        NewsLanguageCode: params.newsLanguageCode,
        NewsType: params.newsType,
        KeyWords: params.keyWord,
        Countury: params.Country,
        Type: params.Type,
        IsPushOut: params.IsPushOut,
        DailyType: params.DailyType
      }
    }
  })
}

export function addNews(params) {
  console.log(params)
  return request({
    url: '/AddNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 202,
      MessageID: btcguid(),
      Data: {
        NewsTitle: params.NewsTitle,
        NewsSummary: params.NewsSummary,
        NewsLanguageCode: params.NewsLanguageCode,
        NewsTitlePic: params.NewsTitlePic,
        NewsDateTime: params.NewsDateTime,
        NewsContext: params.NewsContext,
        KeyWords: params.KeyWords,
        Countury: params.Countury,
        // IsHot: params.IsHot,
        IsPushOut: params.IsPushOut,
        IsTopNews: params.IsTopNews,
        Type: params.Type,
        Continent: params.Continent,
        SubType: params.SubType,
        RelevanceID: params.RelevanceID,
        VideoLink: params.VideoLink,
        DailyType: params.DailyType
      }
    }
  })
}

export function updateNews(params) {
  return request({
    url: '/UpdateNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 203,
      MessageID: btcguid(),
      Data: {
        NewsID: params.NewsID,
        NewsTitle: params.NewsTitle,
        NewsSummary: params.NewsSummary,
        NewsLanguageCode: params.NewsLanguageCode,
        NewsTitlePic: params.NewsTitlePic,
        NewsDateTime: params.NewsDateTime,
        NewsContext: params.NewsContext,
        KeyWords: params.KeyWords,
        Countury: params.Countury,
        // IsHot: params.IsHot,
        IsPushOut: params.IsPushOut,
        IsTopNews: params.IsTopNews,
        Type: params.Type,
        Continent: params.Continent,
        SubType: params.SubType,
        RelevanceID: params.RelevanceID,
        VideoLink: params.VideoLink,
        DailyType: params.DailyType
      }
    }
  })
}

export function deleteNews(params) {
  return request({
    url: '/DeleteNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 204,
      MessageID: btcguid(),
      Data: {
        NewsID: params.NewsID
      }
    }
  })
}

export function getReadedNews(userID) {
  return request({
    url: '/GetReadedNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 205,
      MessageID: btcguid(),
      Data: {
        UserID: userID
      }
    }
  })
}

export function getSimilarArticle(newsid) {
  return request({
    url: '/GetSimilarArticle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 206,
      MessageID: btcguid(),
      Data: {
        NewsID: newsid
      }
    }
  })
}

export function addSimilarArticle(params) {
  return request({
    url: '/AddSimilarArticle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 207,
      MessageID: btcguid(),
      Data: {
        RecNewsID: params.RecNewsID,
        NewsID: params.NewsID,
        UserID: params.UserID
      }
    }
  })
}

export function deleteSimilarArticle(params) {
  return request({
    url: '/DeleteSimilarArticle',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 208,
      MessageID: btcguid(),
      Data: {
        RecNewsID: params.RecNewsID,
        NewsID: params.NewsID
      }
    }
  })
}

export function getIndexReport(params) {
  return request({
    url: '/GetIndexReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 209,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        ReportType: params.ReportType,
        LanguageCode: params.LanguageCode
      }
    }
  })
}

export function addIndexReport(params) {
  return request({
    url: '/AddIndexReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 210,
      MessageID: btcguid(),
      Data: {
        ReportTitle: params.ReportTitle,
        ReportContent: params.ReportContent,
        ReportDateTime: params.ReportDateTime,
        ReportType: params.ReportType,
        IsPushOut: params.IsPushOut,
        ReportCover: params.ReportCover,
        VideoLink: params.VideoLink,
        IsFree: params.IsFree,
        RelevanceID: params.RelevanceID,
        LanguageCode: params.LanguageCode,
        Type: params.Type,
        DailyType: params.DailyType
      }
    }
  })
}

export function updateIndexReport(params) {
  return request({
    url: '/UpdateIndexReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 211,
      MessageID: btcguid(),
      Data: {
        ReportID: params.ReportID,
        ReportTitle: params.ReportTitle,
        ReportContent: params.ReportContent,
        ReportDateTime: params.ReportDateTime,
        ReportType: params.ReportType,
        IsPushOut: params.IsPushOut,
        ReportCover: params.ReportCover,
        VideoLink: params.VideoLink,
        IsFree: params.IsFree,
        RelevanceID: params.RelevanceID,
        LanguageCode: params.LanguageCode,
        DailyType: params.DailyType
      }
    }
  })
}

export function deleteIndexReport(params) {
  return request({
    url: '/DeleteIndexReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 212,
      MessageID: btcguid(),
      Data: {
        ReportID: params.ReportID
      }
    }
  })
}

export function getPriceIndexList(params) {
  return request({
    url: '/GetPriceIndexList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 213,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Type: params.Type,
        Country: params.Country,
        Part: params.Part
      }
    }
  })
}

export function addUpdatePriceIndex(params) {
  return request({
    url: '/AddUpdatePriceIndex',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 214,
      MessageID: btcguid(),
      Data: {
        IndexID: params.IndexID,
        IndexDate: params.IndexDate,
        IndexPrice: params.IndexPrice,
        Country: params.Country,
        Part: params.Part,
        Type: params.Type
      }
    }
  })
}

export function deletePriceIndex(indexID) {
  return request({
    url: '/DeletePriceIndex',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 215,
      MessageID: btcguid(),
      Data: {
        IndexID: indexID
      }
    }
  })
}

export function deleteBeefPriceDataIndex(params) {
  return request({
    url: '/DeleteBeefPriceDataIndex',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 204,
      MessageID: btcguid(),
      Data: {
        IndexIDs: params.IndexIDs
      }
    }
  })
}

export function deleteBeefDataEstPatterns(params) {
  return request({
    url: '/DeleteBeefDataEstPatterns',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 204,
      MessageID: btcguid(),
      Data: {
        EstPatternIDs: params.EstPatternIDs
      }
    }
  })
}

export function pushNews(params) {
  return request({
    url: '/PushNews',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 216,
      MessageID: btcguid(),
      Data: {
        NewsID: params.NewsID,
        NewsTitle: params.NewsTitle,
        NewsType: params.NewsType
      }
    }
  })
}

export function getNewsCommentList(params) {
  return request({
    url: '/GetNewsCommentList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 217,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        IsPushOut: params.IsPushOut
      }
    }
  })
}

export function getTipoffCommentList(params) {
  return request({
    url: '/GetTipoffCommentList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 218,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function commentOperation(params) {
  return request({
    url: '/CommentOperation',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 219,
      MessageID: btcguid(),
      Data: {
        CommentID: params.CommentID,
        IsPushOut: params.IsPushOut
      }
    }
  })
}

export function deleteNewsComment(params) {
  return request({
    url: '/DeleteNewsComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 220,
      MessageID: btcguid(),
      Data: {
        CommentID: params.CommentID
      }
    }
  })
}

export function getUserFinalPrice(params) {
  return request({
    url: '/GetUserFinalPrice',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 221,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        OriginPlace: params.OriginPlace,
        Part: params.Part,
        KeyWords: params.KeyWords
      }
    }
  })
}

export function addMarketPriceData(params) {
  return request({
    url: '/AddMarketPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 222,
      MessageID: btcguid(),
      Data: {
        OriginPlace: params.OriginPlace,
        Part: params.Part,
        ReportID: params.ReportID,
        MaxReferencePrice: params.MaxReferencePrice,
        ReferencePrice: params.ReferencePrice,
        MinReferencePrice: params.MinReferencePrice,
        DMaxReferencePrice: params.DMaxReferencePrice,
        DReferencePrice: params.DReferencePrice,
        DMinReferencePrice: params.DMinReferencePrice,
        FeedingMode: params.FeedingMode,
        Level: params.Level,
        CattleType: params.CattleType,
        FeedingDays: params.FeedingDays,
        Note: params.Note,
        Type: params.Type,
        IsPlantNum: params.IsPlantNum,
        IndexPrice: params.IndexPrice,
        CreateDate: params.CreateDate
      }
    }
  })
}

export function getMarketPriceData(params) {
  return request({
    url: '/GetMarketPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 223,
      MessageID: btcguid(),
      Data: {
        ReportID: params.ReportID
      }
    }
  })
}

export function updateMarketPriceData(params) {
  return request({
    url: '/UpdateMarketPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 223,
      MessageID: btcguid(),
      Data: {
        BeefPriceDataID: params.BeefPriceDataID,
        OriginPlace: params.OriginPlace,
        Part: params.Part,
        ReportID: params.ReportID,
        MaxReferencePrice: params.MaxReferencePrice,
        ReferencePrice: params.ReferencePrice,
        MinReferencePrice: params.MinReferencePrice,
        DMaxReferencePrice: params.DMaxReferencePrice,
        DReferencePrice: params.DReferencePrice,
        DMinReferencePrice: params.DMinReferencePrice,
        FeedingMode: params.FeedingMode,
        Level: params.Level,
        CattleType: params.CattleType,
        FeedingDays: params.FeedingDays,
        Note: params.Note,
        Type: params.Type,
        IsPlantNum: params.IsPlantNum,
        IndexPrice: params.IndexPrice,
        CreateDate: params.CreateDate
      }
    }
  })
}

export function deleteMarketPriceData(params) {
  return request({
    url: '/DeleteMarketPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 223,
      MessageID: btcguid(),
      Data: {
        BeefPriceDataID: params.BeefPriceDataID
      }
    }
  })
}

export function deletePriceDataResearchs(params) {
  return request({
    url: '/DeletePriceDataResearchs',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 204,
      MessageID: btcguid(),
      Data: {
        IDs: params.IDs
      }
    }
  })
}

export function deleteBeefNewImportExportDatas(params) {
  return request({
    url: '/DeleteBeefNewImportExportDatas',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 204,
      MessageID: btcguid(),
      Data: {
        ImportExportDataIDs: params.ImportExportDataIDs
      }
    }
  })
}

export function updateUserMarketPriceData(params) {
  return request({
    url: '/UpdateUserMarketPriceData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 224,
      MessageID: btcguid(),
      Data: {
        State: params.State,
        BeefUserFinalPriceID: params.BeefUserFinalPriceID
      }
    }
  })
}

export function updateCompanyInfo(params) {
  return request({
    url: '/UpdateCompanyInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 225,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        ImportLevel: params.ImportLevel,
        ImportQualification: params.ImportQualification,
        CompanyRole: params.CompanyRole,
        YearFounded: params.YearFounded,
        CompanyTradeName: params.CompanyTradeName,
        PlantNo: params.PlantNo
      }
    }
  })
}

export function updateBeefPriceDataIndex(params) {
  return request({
    url: '/UpdateBeefPriceDataIndex',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 225,
      MessageID: btcguid(),
      Data: {
        IndexID: params.IndexID,
        IndexTime: params.IndexTime,
        IndexPrice: params.IndexPrice,
        Origin: params.Origin,
        Part: params.Part,
        Type: params.Type,
        FeedingMode: params.FeedingMode
      }
    }
  })
}

export function updatePriceDataResearchs(params) {
  return request({
    url: '/UpdatePriceDataResearchs',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 225,
      MessageID: btcguid(),
      Data: {
        ID: params.ID,
        ReferencePrice: params.ReferencePrice,
        Origin: params.Origin,
        OriginEn: params.OriginEn,
        Company: params.Company,
        EstNo: params.EstNo,
        EstNoCode: params.EstNoCode,
        Cuts: params.Cuts,
        CutsCode: params.CutsCode,
        Order: params.Order,
        CreateTime: params.CreateTime
      }
    }
  })
}

export function getBackendIndexReport(params) {
  return request({
    url: '/GetBackendIndexReport',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 226,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Key: params.Type,
        LanguageCode: params.LanguageCode,
        DailyType: params.DailyType
      }
    }
  })
}

export function selectBeefPriceDataIndex(params) {
  return request({
    url: '/SelectBeefPriceDataIndex',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 233,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getPriceDataResearchs(params) {
  return request({
    url: '/GetPriceDataResearchs',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 233,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getBeefNewImportExportDatasList(params) {
  return request({
    url: '/GetBeefNewImportExportDatasList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 233,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getBeefDataEstPatternList(params) {
  return request({
    url: '/GetBeefDataEstPatternList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 233,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords
      }
    }
  })
}

export function updateBeefNewImportExportDatas(params) {
  return request({
    url: '/UpdateBeefNewImportExportDatas',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 225,
      MessageID: btcguid(),
      Data: {
        Type: params.Type,
        Storage: params.Storage,
        Origin: params.Origin,
        OriginEn: params.OriginEn,
        Feeding: params.Feeding,
        Volume: params.Volume,
        Date: params.Date,
        Destination: params.Destination,
        DestinationEn: params.DestinationEn,
        ImportExportDataID: params.ImportExportDataID
      }
    }
  })
}

export function updateBeefDataEstPatterns(params) {
  return request({
    url: '/UpdateBeefDataEstPatterns',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 225,
      MessageID: btcguid(),
      Data: {
        Country: params.Country,
        CompanyNum: params.CompanyNum,
        NormalPlantNum: params.NormalPlantNum,
        StopPlantNum: params.StopPlantNum,
        Ratio1: params.Ratio1,
        Ratio2: params.Ratio2,
        Tariff: params.Tariff,
        Vat: params.Vat,
        CountryEn: params.CountryEn,
        type: params.type,
        EstPatternID: params.EstPatternID
      }
    }
  })
}

export function getFuturesMarketData(params) {
  return request({
    url: '/GetFuturesMarketData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 227,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Origin: params.Origin,
        Cuts: params.Cuts,
        PlantNo: params.PlantNo,
        Type: params.Type
      }
    }
  })
}

export function getSpotMarketData(params) {
  return request({
    url: '/GetSpotMarketData',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 228,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        Origin: params.Origin,
        Cuts: params.Cuts,
        PlantNo: params.PlantNo,
        Type: params.Type
      }
    }
  })
}

export function importFuturesMarketData(params) {
  const formData = new FormData()
  formData.append('MessageType', 229)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportFuturesMarketData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importSpotMarketData(params) {
  const formData = new FormData()
  formData.append('MessageType', 230)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportSpotMarketData',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function getNewsViewUser(params) {
  return request({
    url: '/GetNewsViewUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 231,
      MessageID: btcguid(),
      Data: {
        NewsID: params.NewsID,
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        CountType: params.CountType
      }
    }
  })
}

export function importPriceDataIndexs(params) {
  const formData = new FormData()
  formData.append('MessageType', 231)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPriceDataIndexs',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importPriceDataResearchs(params) {
  const formData = new FormData()
  formData.append('MessageType', 231)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportPriceDataResearchs',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}

export function importBeefNewImportExportDatas(params) {
  const formData = new FormData()
  formData.append('MessageType', 232)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportBeefNewImportExportDatas',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}
// ImportBeefDataEstPatterns
export function importBeefDataEstPatterns(params) {
  const formData = new FormData()
  formData.append('MessageType', 232)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  return request({
    url: '/ImportBeefDataEstPatterns',
    method: 'post',
    headers: {
      'Authorization': getToken(),
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  })
}



// WEBPACK FOOTER //
// ./src/api/news.js